import React from "react";
import PropTypes from "prop-types";

// Filters.
import useOverviewContext from "../../store/use-overview-context";
import { FormattedMessage } from "react-intl";
import FiltersControlFacet from "./filters-control-facet";
import FiltersControlReset from "./filters-control-reset";
import FiltersControlField from "./filters-control-field";
import FiltersControlSorting from "./filters-control-sorting";
import SearchInput from "./search-input";
import { useMediaQuery } from "react-responsive";
import { LockBodyScroll } from "../../../../../../hooks/useLockBodyScroll";

/**
 * Renders a set of filters for a specific view.
 */
const Filters = ({ filterOpen, closeFilters }) => {
  const { config } = useOverviewContext();

  const filtersExist = config.fields.length > 0 || config.facets.length > 0;

  const isMobile = useMediaQuery({ query: "(max-width: 89.9rem)" });

  // If no filters are exposed, return null.
  if (!filtersExist) return null;

  return (
    <>
      {((filterOpen && isMobile) || !isMobile) && (
        <>
          <div className="filter-wrapper">
            {filterOpen && <LockBodyScroll />}
            <form>
              <div className="filters">
                {config.facets.map((facet) => {
                  if (facet.type === "search") {
                    return <SearchInput key="search" onSubmit={closeFilters} />;
                  }
                  return (
                    <FiltersControlFacet
                      id={facet.id}
                      label={facet.label}
                      key={facet.id}
                      multiple={facet.multiple}
                      className={facet.className}
                    />
                  );
                })}
              </div>
            </form>
          </div>

          {config.fields && config.fields?.length > 0 && (
            <div className="col-8 col-sm-4">
              <div className="filters-controlsection">
                <div className="filters-controlsection-label">
                  <span>
                    <FormattedMessage id="controls.mediatype.label" />
                  </span>
                </div>

                <div className="filters-controlsection-controls">
                  {config.fields.map((field) => {
                    return (
                      <FiltersControlField
                        id={field.id}
                        label={field.label}
                        key={field.id}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {config.sorting && config.sorting.length > 0 && (
            <div className="col-8 col-sm-4">
              <div className="filters-controlsection">
                <div className="filters-controlsection-label">
                  <span>
                    <FormattedMessage id="controls.sort.label" />
                  </span>
                </div>

                <div className="filters-controlsection-controls">
                  {config.sorting.map((field) => {
                    return (
                      <FiltersControlSorting
                        id={field.id}
                        label={field.label}
                        key={field.id}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

Filters.propTypes = {
  viewId: PropTypes.string,
  onChange: PropTypes.func,
};

export default Filters;
